import { orchestrator } from 'satcheljs';
import { owaAccountStoreInitializationFailed } from 'owa-account-store-init';
import { getIsLeftNavShown } from '../selectors/getIsLeftNavShown';
import { setIsLeftNavShown } from '../mutators/leftNavStateMutators';

orchestrator(owaAccountStoreInitializationFailed, actionMessage => {
    const { isRetry } = actionMessage;
    if (isRetry && !getIsLeftNavShown()) {
        setIsLeftNavShown(true);
    }
});
